type Props = {
  circleId: string;
  linearGradientId: string;
  className?: string;
  classList?: string;
  position?: {};
  matrix: string;
  stopColor?: {
    color: string;
    offset: number;
  }[];
  pathId?: string;
};

const CircleSvg = ({
  circleId,
  linearGradientId,
  classList,
  className,
  position = {},
  stopColor = [],
  matrix,
  pathId,
}: Props) => {
  return (
    <span
      id={circleId}
      className={className + " " + classList}
      style={position}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: "visible" }}
        viewBox="0 0 650 650"
      >
        <defs>
          <linearGradient
            id={linearGradientId}
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            {stopColor &&
              stopColor.map((stop, i) => {
                return (
                  <stop
                    className={className + "-" + (i + 1)}
                    key={stop.color + i}
                    offset={`${stop.offset}%`}
                    stopColor={stop.color}
                  />
                );
              })}
          </linearGradient>
        </defs>
        <g data-name="Ellipse 38 1" transform="translate(0,8)" fill="none">
          <path
            d="M321.5,0C499.057,0,643-143.94,643-321.506S499.068-643,321.5-643,0-499.06,0-321.494,143.943,0,321.5,0Z"
            stroke="none"
          />
          <path
            id={pathId}
            d="M 321.5 -1 C 343.2459106445312 -1 364.9779052734375 -3.190749883651733 386.0923461914062 -7.511416435241699 C 406.669677734375 -11.72224998474121 426.91015625 -18.00525093078613 446.2517395019531 -26.18616676330566 C 465.242431640625 -34.21858215332031 483.55908203125 -44.16058349609375 500.6928405761719 -55.73600006103516 C 517.6641845703125 -67.20166778564453 533.6232299804688 -80.36924743652344 548.1268310546875 -94.87291717529297 C 562.6304321289062 -109.3766632080078 575.7979736328125 -125.3359146118164 587.2636108398438 -142.3074188232422 C 598.839111328125 -159.4414215087891 608.7810668945312 -177.7584228515625 616.8135986328125 -196.7494964599609 C 624.9945068359375 -216.0915832519531 631.2776489257812 -236.3326721191406 635.488525390625 -256.9106750488281 C 639.8091430664062 -278.0258483886719 642 -299.7586669921875 642 -321.5054931640625 C 642 -343.2524108886719 639.809326171875 -364.9850769042969 635.4888916015625 -386.0999145507812 C 631.2783203125 -406.6775817871094 624.99560546875 -426.9183349609375 616.815185546875 -446.2597351074219 C 608.7830810546875 -465.2504272460938 598.8414916992188 -483.5667419433594 587.2664794921875 -500.7001647949219 C 575.8013305664062 -517.6710205078125 562.63427734375 -533.6295776367188 548.1309814453125 -548.132568359375 C 533.6277465820312 -562.6355590820312 517.6689453125 -575.8024291992188 500.69775390625 -587.2673950195312 C 483.5640869140625 -598.8422241210938 465.2474060058594 -608.78369140625 446.2564086914062 -616.8156127929688 C 426.9146728515625 -624.9959106445312 406.673583984375 -631.278564453125 386.0954895019531 -635.489013671875 C 364.9803466796875 -639.8093872070312 343.2473449707031 -642 321.5 -642 C 299.7527465820312 -642 278.0196533203125 -639.8092651367188 256.9045104980469 -635.4885864257812 C 236.326416015625 -631.2777709960938 216.0854187011719 -624.9946899414062 196.7435760498047 -616.8138427734375 C 177.7526702880859 -608.7814331054688 159.4360046386719 -598.8394165039062 142.30224609375 -587.263916015625 C 125.331169128418 -575.79833984375 109.3723297119141 -562.6307373046875 94.86900329589844 -548.1270751953125 C 80.36583709716797 -533.6234130859375 67.19875335693359 -517.6641845703125 55.73350143432617 -500.6925964355469 C 44.15850067138672 -483.55859375 34.21691513061523 -465.2416687011719 26.18483352661133 -446.25048828125 C 18.00441741943359 -426.9085083007812 11.72166633605957 -406.6674194335938 7.511083126068115 -386.0893249511719 C 3.190666675567627 -364.9742431640625 1 -343.2414245605469 1 -321.4945068359375 C 1 -299.7489929199219 3.190833330154419 -278.0174255371094 7.511499881744385 -256.9033203125 C 11.72233295440674 -236.3263397216797 18.00550079345703 -216.0861663818359 26.18641662597656 -196.7449188232422 C 34.21891784667969 -177.7545776367188 44.16091537475586 -159.4382476806641 55.73641586303711 -142.3047485351562 C 67.20207977294922 -125.3337478637695 80.36958312988281 -109.3749160766602 94.8731689453125 -94.87158203125 C 109.3767471313477 -80.3681640625 125.3358306884766 -67.20092010498047 142.3071594238281 -55.73541641235352 C 159.44091796875 -44.1601676940918 177.7575836181641 -34.21833419799805 196.7482452392578 -26.18600082397461 C 216.0898284912109 -18.00516700744629 236.3304138183594 -11.72216701507568 256.9076538085938 -7.511416435241699 C 278.0221557617188 -3.190749883651733 299.7541809082031 -1 321.5 -1 M 321.5 -5.684341886080801e-14 C 143.9428405761719 -5.684341886080801e-14 5.684341886080801e-14 -143.9403381347656 5.684341886080801e-14 -321.4945068359375 C 5.684341886080801e-14 -499.0595703125 143.9317474365234 -643 321.5 -643 C 499.0682373046875 -643 643 -499.0706787109375 643 -321.5054931640625 C 643 -143.9403381347656 499.0571594238281 -5.684341886080801e-14 321.5 -5.684341886080801e-14 Z"
            transform={matrix}
            stroke={`url(#${linearGradientId})`}
            fill={`url(#${linearGradientId})`}
          />
        </g>
      </svg>
    </span>
  );
};
export default CircleSvg;
